import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, Link, redirect } from '@tanstack/react-router';
import { HTTPError } from 'ky';
import { UserCard } from '../../../features/users/components/user-card';
import { userByIdOptions } from '../../../features/users/queries';
import { PageHeader } from '../../../shared/components/page-header';

export const Route = createFileRoute('/_authenticated/users/$userId')({
  staticData: { breadcrumb: 'Карточка' },
  loader: async ({ context, params }) => {
    try {
      await context.queryClient.ensureQueryData(userByIdOptions(params.userId));
    } catch (e) {
      if (e instanceof HTTPError && (e.response.status === 404 || e.response.status === 400)) {
        throw redirect({ to: '/users' });
      }
      throw e;
    }
  },
  component: UserCardPage,
});

function UserCardPage() {
  const { userId } = Route.useParams();
  const { data } = useSuspenseQuery(userByIdOptions(userId));
  return (
    <div className="space-y-4">
      <PageHeader
        title={`@${data.username ?? '—'}`}
        description={
          <Link to="/users" className="text-sm hover:underline">
            ← К списку
          </Link>
        }
      />
      <UserCard user={data} />
    </div>
  );
}
